<template>
  <div class="statistics-data">
    <div class="title">
      <div><img src="@/assets/img/icon/icon17.png" alt="" />学习数据</div>
      <p>当前数据可视化是对学习进度变化的实时记录</p>
    </div>
    <div class="data-box">
      <div>
        <p>课程完成进度</p>
        <div>
          {{ info.chapterCompleteCount }}<span>/{{ info.chapterCount }}</span>
        </div>
      </div>
      <div>
        <p>学习资源完成进度</p>
        <div>
          {{ info.resourceCompleteCount }}<span>/{{ info.resourceCount }}</span>
        </div>
      </div>
      <div>
        <p>学习完成率</p>
        <div>
          <!-- Math.round() -->
          {{ (info.chapterCompleteCount / info.chapterCount) * 100 }}%
        </div>
      </div>
      <div>
        <p>学习次数</p>
        <div>{{ info.studyCount || 0 }}<span>次</span></div>
      </div>
      <div>
        <p>学习总时长</p>
        <div>{{ (info.studyTime / 60).toFixed(2) }}<span>分钟</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.statistics-data {
  width: 588px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e6eaf0;
  padding: 0 24px;
  > .title {
    padding: 24px 0;
    border-bottom: 1px solid #ebedf0;
    > div {
      font-size: 16px;
      font-weight: 600;
      color: #323233;
      line-height: 22px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      > img {
        margin-right: 8px;
      }
    }
    > p {
      font-size: 14px;
      font-weight: 400;
      color: #969799;
      line-height: 22px;
    }
  }
  > .data-box {
    display: flex;
    flex-wrap: wrap;
    padding-top: 21px;
    > div {
      width: 30%;
      margin-top: 8px;
      margin-bottom: 32px;
      > p {
        font-size: 14px;
        font-weight: 400;
        color: #969799;
        line-height: 20px;
        margin-bottom: 8px;
      }
      > div {
        font-size: 32px;
        font-weight: 500;
        color: #323233;
        line-height: 44px;
        > span {
          font-size: 14px;
          font-weight: 400;
          color: #969799;
          line-height: 20px;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
